import companyReportsActions from '../actionTypes/companyReportsActions';
import dateTimeHelpers from '../utils/dateTimeHelpers';
const initialState = {
  isLoading: true,
  per: 10,
  page: 1,
  from: dateTimeHelpers.dateBeforeMonths(1),
  to: dateTimeHelpers.today().dateTime,
  data: {
    orders_for_day: [],
    orders: [],
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case companyReportsActions.getCompanyReports:
      return { ...state, ...action.payload, isLoading: true };
    case companyReportsActions.getCompanyReportsSuccess:
      return { ...state, ...action.payload, isLoading: false };
    case companyReportsActions.getCompanyReportsFailed:
      return {
        ...initialState,
        ...action.payload,
        errors: [],
        isLoading: false,
      };
    default:
      return state;
  }
};
